module.exports = __webpack_public_path__ + "img/Samurai-Wolven-Logo-Template.jpg";